import type {SplitName} from '@/config';
import type {Split} from '@travel-frontend/split-io';

import {useSplit} from '@travel-frontend/split-io';

export const useLocalSplit = <
  Treatment extends string = 'on' | 'off' | 'default',
>(
  splitName: SplitName
): Split<Treatment> => useSplit<Treatment>(splitName);
